/**
 * Injection keys para el contexto de perfil.
 *
 * Usar símbolos en vez de strings evita colisiones silenciosas y deja
 * explícito el contrato de lo que se inyecta.
 *
 * Contrato de `PERFIL_EDITING_KEY`:
 * {
 *   isEditing:     Ref<boolean>
 *   localData:     Ref<object>
 *   loading:       Ref<boolean>
 *   errors:        Ref<object>
 *   startEditing:  () => void
 *   cancelEditing: () => void
 *   save:          (validateFn?: () => Promise<boolean>) => Promise<{ success: boolean }>
 * }
 */
export const PERFIL_EDITING_KEY = Symbol('perfilEditing');
